import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isQuizLongText(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.QUIZ_LONG_TEXT && typeof label === 'string' && typeof value === 'string';
}
function _formatQuizLongText(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return undefined;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatQuizLongText(submission) {
  if (isQuizLongText(submission)) {
    return _formatQuizLongText(submission);
  }
  return undefined;
}
//# sourceMappingURL=quiz-long-text-preview.js.map